<template>
  <EdgeStack
    :id="esId"
    :exitButton="{ text: 'Cancel', hidden: false }"
    :size-class="`w-full md:w-2/5`"
  >
    <template #header>
      <div class="flex justify-between -mt-8">
        <div class="panel-title">Report</div>
      </div>
      <div
        v-if="reportType === 'vehicle-fleet-update' && extraData.name"
        class="text-gray-500 text-base font-semibold mt-3"
      >
        Fleet:
        <span
          ><router-link
            :to="{
              name: 'ViewFleetVehicles',
              params: { id: extraData.id },
            }"
            :class="`text-blue-600`"
            target="_blank"
          >
            {{ extraData.name }}
          </router-link></span
        >
      </div>
    </template>

    <template #footer>
      <AppButton
        variant="primary"
        :text="`Export`"
        @click="handleBulkTaskReportExport"
      />
    </template>

    <template #default>
      <template>
        <div :key="esId" class=" mt-3 pt-5 border-oLightestGray border-t-2">
          <STable :sId="esId" :headers="getHeaders">
            <template v-for="(reportItem, reportItemIndex) in bulkReports">
              <STableRow :key="reportItemIndex" text-fallback-always>
                <STableRowItem
                  :to="{
                    name: 'ViewVehicleProfile',
                    params: { id: reportItem.id },
                  }"
                  target="_blank"
                  :text="reportItem.qr_code"
                />

                <STableRowItem>
                  <template v-if="reportItem.success">
                    <i class=" text-green-500 fas fa-check-circle" />
                  </template>
                  <template v-else>
                    <i class=" text-oRed fas fa-exclamation-circle" />
                  </template>
                </STableRowItem>
                <STableRowItem
                  :text="reportItem.failure_reason"
                /> </STableRow></template
          ></STable>
        </div>
      </template>
    </template>
  </EdgeStack>
</template>
<script>
import { EdgeStack } from '@/components/modals'
import { STable, STableRow, STableRowItem } from '@/components/s-table'
import { exportHeaderGroup, getTransformRowData } from '@/utils/export-data'
import { saveAs } from 'file-saver'

export default {
  name: 'BulkActionReport',
  components: {
    EdgeStack,
    STable,
    STableRow,
    STableRowItem,
  },
  props: {
    esId: {
      type: String,
      default: 'bulk-action-report',
    },
    reportType: {
      type: String,
      default: 'vehicle-fleet-update',
      validator(val) {
        return ['vehicle-fleet-update'].includes(val)
      },
    },
    bulkReports: {
      type: Array,
      default: () => [],
    },
    extraData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      reportName: {
        'vehicle-fleet-update': 'bulkVehicleFleetReport',
      },
      vehicleReportHeaders: [
        {
          text: 'Qr Code',
          width: '20%',
          sort: null,
        },
        {
          text: 'Status',
          width: '10%',
          sort: null,
        },
        {
          text: 'Failed Reason',
          width: '70%',
          sort: null,
        },
      ],
    }
  },

  computed: {
    getHeaders() {
      if (this.reportType === 'vehicle-fleet-update') {
        return this.vehicleReportHeaders
      } else {
        return []
      }
    },
  },

  methods: {
    csvMaker(data) {
      const csvRows = []

      const headers = exportHeaderGroup[this.reportName[this.reportType]].map(
        (x) => x.title
      )

      csvRows.push(headers.join(','))
      for (let i = 0; i < data.length; i++) {
        const values = Object.values(
          getTransformRowData(data[i], this.reportName[this.reportType])
        ).join(',')
        csvRows.push(values)
      }

      return csvRows.join('\n')
    },
    handleBulkTaskReportExport() {
      const blob = new Blob([this.csvMaker(this.bulkReports)], {
        type: 'text/csv',
      })
      const fileName = `${this.reportType}_bulk_report.csv`
      saveAs(blob, fileName)
    },
  },
}
</script>

<style scoped>
.panel-title {
  font-size: 22px;
  font-weight: 500;
  color: #2e2e39;
}
</style>
